<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt" id="Hnotas">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dCincoM dtOcho dmOnce">
                    <h1>CUIDA TU SALUD</h1>
                    <p>Ponemos a su disposición información de interés que le ayudará a saber más acerca de enfermedades y acciones relacionadas a cuidar su salud y la de su familia.</p>
                </div>
                <div class="dCinco dtDos dmMedio">
                    <input (blur)="onBlur($event)" autocomplete="off" #input type="text" class="form-control buscador"
                        id="formGroupExampleInput" (keyup)="buscador(input.value)" placeholder="¿Qué estás buscando?" />
                </div>
            </div>
        </header>
    </div>
<div class="contenedorIntSub">
    <div class="Fnotas dDiez dtDiezM dmOnce flx" id="FnotasPag01">
        <div class="FnotaItem dSeis dmDoce flx" *ngFor="let nota of notas | paginate: {itemsPerPage: 14, currentPage: pageActual}">
            <div class="FnotaItemImagen dCinco">
                <a  [routerLink]="'/nota/' + nota.url ">
                    <!-- <img src="{{nota.thumb}}" alt="{{nota.titulo}}" (click)="getNotaUrl(nota)"> -->
                    <picture>
                        <source type="image/webp" srcset="{{nota.urlimagenWebp}}">
                        <source type="image/jpg" srcset="{{nota.urlimagen}}">
                        <img src="{{nota.img}}" class="img-fluid imgnota" >
                    </picture>
                </a>
            </div>

            <div class="FnotaItemTexto dSiete">
                <div class="FnotaItemTitle dDoce">
                    <h5>{{nota.titulo}}</h5>
                </div>
                <a  [routerLink]="'/nota/' + nota.url ">
                    <button class="dOcho dtDiez">VER NOTA</button>
                </a> 
                               
            </div>
        </div>
        <div class="dDoce Fpag">
            <pagination-controls (pageChange)="pageActual = $event" previousLabel="Anterior" nextLabel="Siguiente" style="margin: auto;">
            </pagination-controls>
        </div>
    </div>
</div>
</div>